import { useContext } from "react";
import { PageContext } from "@contexts/PageContext";

export function usePage() {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error("usePage must be used within <PageProvider>");
  }
  return context;
}
